

let envConfig = {};
const devConfig = {
 
  loginPageUrl: "http://localhost:3000/",
  userCheckApiUrl: "http://localhost:3301/v1/user/check/otherApp",
  userAuthApiUrl: "http://localhost:3301",
  apiUrl: "http://localhost:3305",
  submissionManagedSystemUrl :"http://localhost:3305"

};
const testConfig = {
  apiUrl: "https://testbilsis.ayk.gov.tr/api/",
  loginPageUrl: "https://testgiris.ayk.gov.tr/",
  userCheckApiUrl: "https://testgiris.ayk.gov.tr/api/v1/user/check/otherApp",
  userAuthApiUrl: "https://testgiris.ayk.gov.tr/api/",
  submissionManagedSystemUrl :"https://testgiris.ayk.gov.tr"
};
const prodConfig = {
  apiUrl: "https://bilsis.ayk.gov.tr/api/",
  loginPageUrl: "https://giris.ayk.gov.tr/",
  userCheckApiUrl: "https://giris.ayk.gov.tr/api/v1/user/check/otherApp",
  userAuthApiUrl: "https://giris.ayk.gov.tr/api/",
  submissionManagedSystemUrl :"https://giris.ayk.gov.tr"
};
if (process.env.REACT_APP_ENV === "development") {
  envConfig = devConfig;
} else if (process.env.REACT_APP_ENV === "test") {
  envConfig = testConfig;
} else if (process.env.REACT_APP_ENV === "production") {
  envConfig = prodConfig;
}
else
{
  envConfig = devConfig;
}
//export  {envConfig};
////console.log("env config",envConfig);
export default {
  apiUrl: envConfig.apiUrl,
  loginPageUrl: envConfig.loginPageUrl,
  userCheckApiUrl: envConfig.userCheckApiUrl,
  userAuthApiUrl: envConfig.userAuthApiUrl,

  defaultProfileImageUrl: "/uploads/images/user.jpg",

  instImageUrlAKMB: "/images/akmb.png",
  instImageUrlATAM: "/images/atam.png",
  instImageUrlTTK: "/images/ttk.png",
  instImageUrlTDK: "/images/tdk.png",

  activityPageUrl:"www.etkinlik.gov.tr/",
  submissionManagedSystemUrl : envConfig.submissionManagedSystemUrl,

  copright: "Her hakkı saklıdır. Atatürk Kültür, Dil ve Tarih Yüksek Kurumu",
  coprightYear: "2020",

  signOutUrl: "/bbs/mainPage",
  signInUrl: "/bys/mainPage",

  appName :"Sosyal Bilimler Etkinlikleri",

  titleList: [
    "Dr Öğretim Üyesi",
    "Prof.Dr.",
    "Doç.Dr.",
    "Öğretim Görevlisi",
    "Araştırma Görevlisi",
    "Dr.",
    "Öğretmen",
    "Diğer"
  ],
  mounth: [
    "Ocak",
    "Şubat",
    "Mart",
    "Nisan",
    "Mayıs",
    "Haziran",
    "Temmuz",
    "Ağustos",
    "Eylül",
    "Ekim",
    "Kasım",
    "Aralık"
  ],
  citys: [
    "",
    "Adana",
    "Adıyaman",
    "Afyon",
    "Ağrı",
    "Amasya",
    "Ankara",
    "Antalya",
    "Artvin",
    "Aydın",
    "Balıkesir",
    "Bilecik",
    "Bingöl",
    "Bitlis",
    "Bolu",
    "Burdur",
    "Bursa",
    "Çanakkale",
    "Çankırı",
    "Çorum",
    "Denizli",
    "Diyarbakır",
    "Edirne",
    "Elazığ",
    "Erzincan",
    "Erzurum",
    "Eskişehir",
    "Gaziantep",
    "Giresun",
    "Gümüşhane",
    "Hakkari",
    "Hatay",
    "Isparta",
    "Mersin",
    "İstanbul",
    "İzmir",
    "Kars",
    "Kastamonu",
    "Kayseri",
    "Kırklareli",
    "Kırşehir",
    "Kocaeli",
    "Konya",
    "Kütahya",
    "Malatya",
    "Manisa",
    "Kahramanmaraş",
    "Mardin",
    "Muğla",
    "Muş",
    "Nevşehir",
    "Niğde",
    "Ordu",
    "Rize",
    "Sakarya",
    "Samsun",
    "Siirt",
    "Sinop",
    "Sivas",
    "Tekirdağ",
    "Tokat",
    "Trabzon",
    "Tunceli",
    "Şanlıurfa",
    "Uşak",
    "Van",
    "Yozgat",
    "Zonguldak",
    "Aksaray",
    "Bayburt",
    "Karaman",
    "Kırıkkale",
    "Batman",
    "Şırnak",
    "Bartın",
    "Ardahan",
    "Iğdır",
    "Yalova",
    "Karabük",
    "Kilis",
    "Osmaniye",
    "Düzce"
  ],

  educationLevels: [
    "",
    "Okur-Yazar Değil",
    "Okur-Yazar",
    "İlkokul",
    "Ortaokul",
    "Lise",
    "Lisans",
    "YüksekLisans",
    "Doktora"
  ],

    languagesTR : [{value:"Türkçe"},{value:"İngilizce"},{value:"Almanca"},{value:"Arapça"},{value:"Azerice"},{value:"Kürtçe"},{value:"Çince (Basitleştirilmiş)"},{value:"Çince (Geleneksel)"},{value:"Fransızca"},{value:"Rusça"},{value:"Farsça"},{value:"Filipince"},{value:"İspanyolca"},{value:"İsveççe"},{value:"İtalyanca"},{value:"Japonca"},{value:"Afrikaanca"},{value:"Amharca"},{value:"Arnavutça"},{value:"Baskça"},{value:"Batı Frizcesi"},{value:"Belarusça"},{value:"Bengalce"},{value:"Boşnakça"},{value:"Bulgarca"},{value:"Burmaca"},{value:"Cava Dili"},{value:"Cebuano"},{value:"Çekçe"},{value:"Danca"},{value:"Endonezce"},{value:"Ermenice"},{value:"Esperanto"},{value:"Estonca"},{value:"Felemenkçe"},{value:"Fince"},{value:"Galce"},{value:"Galiçyaca"},{value:"Güceratça"},{value:"Güney Sotho dili"},{value:"Gürcüce"},{value:"Hausa dili"},{value:"Haiti Kreyolu"},{value:"Hawaii dili"},{value:"Hırvatça"},{value:"Hintçe"},{value:"Hmong Dili"},{value:"İbo dili"},{value:"İbranice"},{value:"İrlandaca"},{value:"İskoç Gaelcesi"},{value:"İzlandaca"},{value:"Kannada dili"},{value:"Katalanca"},{value:"Kazakça"},{value:"Kırgızca"},{value:"Kmerce"},{value:"Korece"},{value:"Korsikaca"},{value:"Lao dili"},{value:"Latince"},{value:"Lehçe"},{value:"Letonca"},{value:"Litvanca"},{value:"Lüksemburgca"},{value:"Makedonca"},{value:"Macarca"},{value:"Malayalam dili"},{value:"Malayca"},{value:"Malgaşça"},{value:"Maltaca"},{value:"Maori dili"},{value:"Marathi"},{value:"Moğolca"},{value:"Nepalce"},{value:"Norveççe"},{value:"Nyanja"},{value:"Özbekçe"},{value:"Pencapça"},{value:"Peştuca"},{value:"Portekizce"},{value:"Rumence"},{value:"Samoa dili"},{value:"Seylanca"},{value:"Shona"},{value:"Sırpça"},{value:"Sindhi"},{value:"Slovakça"},{value:"Slovence"},{value:"Somalice"},{value:"Sunda Dili"},{value:"Svahili"},{value:"Tacikçe"},{value:"Tamilce"},{value:"Tayca"},{value:"Telugu dili"},{value:"Ukraynaca"},{value:"Urduca"},{value:"Vietnamca"},{value:"Yidiş"},{value:"Yorubaca"},{value:"Yunanca"},{value:"Zosa dili"},{value:"Zuluca"}],


};
